module.exports = __webpack_public_path__ + "img/cancel.7da6ed0e.svg";